<h1>{{isAirSearchFormVisible ? wording.airSearchHeaderTitleForm : wording.airSearchHeaderTitleResume}}</h1>
<air-search-header-action
        [canUseAirSearchForm]="canUseAirSearchForm"
        [airSearchContext]="airSearchContext"
        [hasAirSearchRequest]="hasAirSearchRequest"
        [isAirSearchFormVisible]="isAirSearchFormVisible">
</air-search-header-action>
